<template>
  <svg  viewBox="0 0 93 91" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M91.5 68.5L46 90.5L0 68.5L46 47L91.5 68.5ZM13.5 68.5L46 84L79 68.5L46 53L13.5 68.5Z" fill="#3B67A0"/>
    <path d="M47 81V56.5L73 68.5L47 81Z" fill="#FF9900"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M89 20V55L92.5 56.5V65L47 43.5V35L50 36.5V1L89 20ZM58 40L81.5 51L82 25L58 13.5V40Z" fill="#3B67A0"/>
    <path d="M0 21V65L7 61.7808V26.5L38 12V47L45 43.7326V0L0 21Z" fill="#3B67A0"/>
  </svg>
</template>

<script>
export default {

};
</script>

<style>

</style>
